import { Building2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Label } from '@/components/ui/label';
import { SimpleSelect, type SelectOption } from '@/shared/ui/filters';

interface OrganizationSelectFilterProps {
  options: SelectOption[];
  value?: string;
  onChange: (value: string | undefined) => void;
  onSearchChange?: (value: string) => void;
  className?: string;
  isLoading?: boolean;
}

export function OrganizationSelectFilter({
  options,
  value,
  onChange,
  onSearchChange,
  className = 'w-full md:w-60',
  isLoading = false
}: OrganizationSelectFilterProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2">
      <Label className="text-sm font-medium flex items-center gap-2">
        <Building2 className="h-4 w-4" />
        {t('dashboard.organization.label', 'Organization')}
      </Label>
      <SimpleSelect
        options={options}
        value={value}
        onChange={onChange}
        onInputValueChange={onSearchChange}
        placeholder={
          isLoading
            ? t('dashboard.organization.loading', 'Loading...')
            : t('dashboard.organization.placeholder', 'Search organization')
        }
        className={className}
      />
    </div>
  );
}
